import { useEffect, useState } from "react";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import Page from "../../../componentes/plantilla/Page";
import { ActuadoresEditar, ActuadoresListar } from "../../../configuracion/apiUrls";

const HomeActuador = () => {
  const datos = {
    titulo: {
      titulo: "Controles principal",
      url: "/app/admin/invernaderos/",
      tituloUrl: "Menú Principal",
      nombreUrl: "Inicio",
    },
  };

  const [actuadores, setActuadores] = useState([]);
  const invernaderoId = localStorage.getItem("invernaderoId") || 1;

  useEffect(() => {
    obtenerActuadores();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActuadores(prevActuadores =>
        prevActuadores.map(act => {
          if (act.estado === 'Activo' && act.timer > 0) {
            return { ...act, timer: act.timer - 1000 };
          }
          return act;
        })
      );
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const obtenerActuadores = async () => {
    try {
      const { data } = await AxiosPublico.get(ActuadoresListar);
      const filtrados = data
        .filter((a) => a.invernaderoId == invernaderoId)
        .map((act) => ({
          ...act,
          duracion: 15000,
          unidad: "ms",
          timer: 0 // Inicia el temporizador en 0
        }));
      setActuadores(filtrados);
    } catch (error) {
      console.error("Error al obtener actuadores", error);
    }
  };

  const handleDuracionChange = (id, value) => {
    setActuadores(prev =>
      prev.map(act =>
        act.id === id ? { ...act, duracion: Number(value) } : act
      )
    );
  };

  const handleUnidadChange = (id, value) => {
    setActuadores(prev =>
      prev.map(act =>
        act.id === id ? { ...act, unidad: value } : act
      )
    );
  };

  const cambiarEstado = async (act) => {
    const nuevoEstado = act.estado === "Activo" ? "Inactivo" : "Activo";

    let duracionEnMs = act.duracion;
    switch (act.unidad) {
      case "s":
        duracionEnMs = act.duracion * 1000;
        break;
      case "m":
        duracionEnMs = act.duracion * 60 * 1000;
        break;
      case "h":
        duracionEnMs = act.duracion * 60 * 60 * 1000;
        break;
      default:
        duracionEnMs = act.duracion;
        break;
    }

    // Actualiza el temporizador en el estado
    setActuadores((prev) =>
      prev.map((a) =>
        a.id === act.id ? {
          ...a,
          estado: nuevoEstado,
          timer: nuevoEstado === "Activo" ? duracionEnMs : 0
        } : a
      )
    );

    try {
      await AxiosPublico.put(`${ActuadoresEditar}${act.id}`, {
        estado: nuevoEstado,
        duracion: duracionEnMs
      });
    } catch (error) {
      console.error("Error al cambiar estado del actuador", error);
    }
  };

  useEffect(() => {
    setActuadores(prev => {
      const actuadorAInactivar = prev.find(act => act.estado === 'Activo' && act.timer <= 0);
      if (actuadorAInactivar) {
        cambiarEstado(actuadorAInactivar);
      }
      return prev;
    });
  }, [actuadores]);

  const focos = actuadores.filter((a) => a.tipo.toLowerCase() === "focos");
  const bombas = actuadores.filter((a) => a.tipo.toLowerCase() === "bombas");
  const ventiladores = actuadores.filter((a) => a.tipo.toLowerCase() === "ventiladores");

  const renderActuadores = (lista, tipo) => {
    const formatTime = (ms) => {
      if (ms <= 0) return "Listo";
      const totalSeconds = Math.floor(ms / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
      if (minutes > 0) return `${minutes}m ${seconds}s`;
      return `${seconds}s`;
    };

    return (
      <div className="row">
        {lista.length === 0 ? (
          <div className="col-12">
            <div className="alert alert-info text-center m-0">
              <i className="fas fa-exclamation-circle me-2 mx-2"></i>
              No hay actuadores registrados para <strong>{tipo}</strong> en este invernadero.
            </div>
          </div>
        ) : (
          lista.map((act) => (
            <div key={act.id} className="col-md-4 mb-4">
              <div className="card border-0 shadow-lg h-100 rounded-4">
                <div className="card-body d-flex flex-column justify-content-between">
                  <div>
                    <p className="card-text text-muted mb-1">ID: {act.id}</p>
                    <h5 className="card-title fw-bold text-primary">{act.nombre}</h5>
                    <p className="card-text text-muted mb-1">Descripción: {act.descripcion}</p>
                    <p className="card-text small text-secondary">
                      Estado actual:{" "}
                      <span className={`fw-bold ${act.estado === "Activo" ? "text-success" : "text-danger"}`}>
                        {act.estado}
                      </span>
                    </p>
                    <p className="card-text text-secondary">
                      Tiempo restante:{" "}
                      <span className="fw-bold fs-4 text-primary">{formatTime(act.timer)}</span>
                    </p>
                  </div>
                  <div className="input-group my-3">
                    <span className="input-group-text">Duración</span>
                    <input
                      type="number"
                      className="form-control"
                      value={act.duracion}
                      onChange={(e) => handleDuracionChange(act.id, e.target.value)}
                      min="0"
                    />
                    <select
                      className="form-select"
                      value={act.unidad}
                      onChange={(e) => handleUnidadChange(act.id, e.target.value)}
                    >
                      <option value="ms">MS</option>
                      <option value="s">S</option>
                      <option value="m">M</option>
                      <option value="h">H</option>
                    </select>
                  </div>
                  <div className="mt-3 text-center">
                    <img
                      src={`/${act.estado === "Activo" ? "Activo.png" : "Inactivo.png"}`}
                      alt={act.estado}
                      style={{ width: "80px", height: "80px", cursor: "pointer" }}
                      onClick={() => cambiarEstado(act)}
                      className="my-2 rounded-circle shadow"
                    />
                    <p className="text-muted small mb-0">Haz clic en la imagen para cambiar estado</p>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  return (
    <Page datos={datos}>
      <Card titulo="Control de los Focos">{renderActuadores(focos, "Focos")}</Card>
      <Card titulo="Control de las Bombas">{renderActuadores(bombas, "Bombas")}</Card>
      <Card titulo="Control de los Ventiladores">{renderActuadores(ventiladores, "Ventiladores")}</Card>
    </Page>
  );
};

export default HomeActuador;